<template>
  <div>
    <v-combobox
      multiple
      readonly
      label="Clubs and Societies"
      :value="value"
      @change="modify"
      :color="themes.candidate.light.input"
      append-icon=""
    >
      <template slot="append-outer">
        <v-chip slot="activator">
          <v-avatar>
            <v-btn
              slot="activator"
              :color="themes.candidate.light.secondaryActionButton"
              @click="adding = true"
              small
              fab
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-avatar>
          Add
        </v-chip>
      </template>
      <template slot="selection" slot-scope="{ item, selected }">
        <v-chip
          :class="themes.candidate.light.chip"
          :selected="selected"
          close
          @input="remove(item.id)"
          :key="`affiliation-${item.id}`"
        >
          <strong>{{ item.name }}</strong>
          &nbsp;
          <span v-if="item.position">({{ item.position }})</span>
        </v-chip>
      </template>
    </v-combobox>

    <v-dialog max-width="500px" v-model="adding">
      <v-card>
        <v-form v-model="valid">
          <v-card-title :class="themes.candidate.light.dialogTitle">
            Add a club or society
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Club or Society name"
              v-model="affiliation.name"
              required
              :rules="rules.name"
              :color="themes.candidate.light.input"
              hint="Please provide the name of the club or society of which you are or were a member"
            />
            <v-text-field
              label="Position held"
              v-model="affiliation.position"
              :rules="rules.position"
              :color="themes.candidate.light.input"
              hint="Please provide the position held in the club or society"
            />
          </v-card-text>

          <v-card-actions
            ><v-spacer />
            <v-btn flat :color="themes.candidate.light.cancel" @click="cancel">Cancel</v-btn>
            <v-btn
              :color="themes.candidate.light.primaryActionButton"
              @click="submit"
              :disabled="!valid"
              >Add</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Vue Component
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      adding: false,
      // Model (object sent to API)
      affiliation: {
        name: '',
        position: '',
      },
      // Validation
      valid: false,
      rules: {
        name: [v => !!v || 'Please add the club or society name.'],
        position: [],
      },
    }
  },
  methods: {
    modify(comboboxValues) {
      // Create any that were newly added
      const newValues = comboboxValues.filter(lp => !lp.id)
      if (newValues.length) this.submit(newValues[0])
      // Remove any that were removed with backspace
      const missingValues = this.value.filter(
        old => !_.some(comboboxValues, newValue => newValue.id == old.id)
      )
      if (missingValues.length) this.remove(missingValues[0].id)
    },
    cancel() {
      if (this.value.id) {
        this.adding = false
        this.affiliation = JSON.parse(JSON.stringify(this.value))
      } else {
        this.dismiss()
      }
    },
    submit() {
      this.$store.dispatch('candidate/affiliations/create', this.affiliation).then(() => {
        this.$store.dispatch('candidate/profile/fetch')
        this.adding = false
        this.affiliation.name = ''
        this.affiliation.position = ''
      })
    },
    dismiss() {
      this.adding = false
      this.affiliation = Object.assign(this.affiliation, {
        name: '',
        position: '',
      })
    },
    remove(id) {
      this.$store
        .dispatch('candidate/affiliations/destroy', id)
        .then(() => this.$store.dispatch('candidate/profile/fetch'))
    },
  },
}
</script>
